var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.58,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8335 10.5001C21.8335 15.8762 17.1644 20.2904 11.3335 20.2904C5.50257 20.2904 0.833496 15.8762 0.833496 10.5001C0.833496 5.12391 5.50257 0.709747 11.3335 0.709747C17.1644 0.709747 21.8335 5.12391 21.8335 10.5001Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0685 15.2097L10.3835 10.5297L7.0385 5.78975H8.4485L11.1635 9.62975L13.6535 5.78975H15.0785L11.8085 10.5147L15.1985 15.2097H13.7585L11.0285 11.4447L8.4785 15.2097H7.0685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.8e5e738011c8bc03c850efb3a14ca50e.svg";
export { ForwardRef as ReactComponent };